var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44119 2.72713C5.46877 2.36181 6.66025 2.59039 7.48273 3.41286C8.41683 4.34695 8.58492 5.75699 7.98692 6.86235L16.9108 15.7872L15.7323 16.9658L6.80818 8.04144C5.70271 8.63986 4.29224 8.47195 3.35793 7.53765C2.53523 6.71495 2.30675 5.52302 2.67251 4.49525L4.53644 6.35915C5.0246 6.8473 5.81606 6.8473 6.30421 6.35915C6.79237 5.87099 6.79237 5.07953 6.30421 4.59138L4.44119 2.72713ZM13.0807 4.29675L15.7323 2.8236L16.9108 4.00212L15.4377 6.65377L13.9645 6.9484L12.1968 8.7162L11.0183 7.53765L12.786 5.76989L13.0807 4.29675ZM7.48273 11.0732L8.66125 12.2517L4.24182 16.6711C3.91638 16.9965 3.38874 16.9965 3.06331 16.6711C2.76112 16.3689 2.73953 15.8924 2.99855 15.5653L3.06331 15.4926L7.48273 11.0732Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.0beb7e5ba3e1fb72141b6a93a19130a5.svg";
export { ForwardRef as ReactComponent };